import { BackdropLoader } from 'components/Loaders/loader';
import * as React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postShipmentsAdd, WatchlistQueryKeys } from 'services/clients/watchList';
import { useSegment } from 'common/hooks/segment';
import { AddForm } from './AddForm';

export const Manual: React.FC = () => {
  const addShipments = useMutation(postShipmentsAdd);
  const queryClient = useQueryClient();
  const { track } = useSegment();
  const [error, setError] = React.useState<string | null>(null);

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <p className="text-gray-900">
          Manually add containers by entering the Ocean Bill of Lading
        </p>
        <h4 className="text-gray-600">
          Use this page to upload multiple containers with corresponding Ocean Bill of Lading
          numbers
        </h4>
      </div>
      <div className="space-y-1">
        <AddForm
          onSubmit={async (billOfLadings) => {
            await addShipments.mutateAsync(
              { billOfLadings },
              {
                onError: (err) => {
                  // eslint-disable-next-line no-console
                  console.error(err);
                  track(
                    'Added shipment',
                    { type: 'manual', billOfLadings, success: false },
                    { includeCompany: true, includeUser: true }
                  );
                },
                onSuccess: (response) => {
                  if (response.code === 'ok') {
                    setError(null);
                    queryClient.invalidateQueries(['watchList']);
                    queryClient.invalidateQueries(['watchListCount']);
                    queryClient.invalidateQueries([WatchlistQueryKeys.WatchedShipments]);
                    track(
                      'Added shipment',
                      { type: 'manual', billOfLadings, success: true },
                      { includeCompany: true, includeUser: true }
                    );
                  } else if (response.code === 'alreadyExists') {
                    setError(`${billOfLadings[0].number} is already being tracked.`);
                  }
                },
              }
            );
          }}
        />
        <div className="text-red text-sm">{error}</div>
      </div>
      <BackdropLoader open={addShipments.isLoading} className="p-32 py-32">
        <div className="space-y-4 pt-8 text-center">
          <h3>Your Bill of Ladings are uploading…</h3>
          <p>This might take a couple of minutes, hang tight.</p>
        </div>
      </BackdropLoader>
    </div>
  );
};
Manual.displayName = 'Shipments.AddContainers.Manual';
